import { useTranslation } from "react-i18next";

export const useTranslatedLinks = () => {
  const { t } = useTranslation('footer', { useSuspense: false });
  const footerTranslate = {
    about: {
      whoAreWe: t('about.whoAreWe'),
      magazine: 'Focus',
      clientReviews: t('about.clientReviews'),
      press: t('about.press')
    },
    help: {
      contactUs: t('contact.question'),
      faq: t('help.faq'),
      termsOfSale: t('help.termsOfSale'),
      privacyPolicy: t('help.privacyPolicy')
    },
    services: {
      mobileApps: t('services.mobileApps'),
      referral: t('services.referral'),
      ourBrands: t('services.ourBrands'),
      currentOffers: t('services.currentOffers')
    },
    client: {
      myAccount: t('client.myAccount'),
      myOrders: t('client.myOrders'),
      myReturns: t('client.myReturns'),
      preferencesCenter: t('client.preferencesCenter')
    },
  }
  const aProposLinks = [
    {
      linkName: footerTranslate.about.whoAreWe,
      linkUrl: '/home/whois/',
      isLoggedIn: false,
    },
    {
      linkName: footerTranslate.about.magazine,
      linkUrl: '/magazine/index/',
      isLoggedIn: false,
    },
    {
      linkName: footerTranslate.about.clientReviews,
      linkUrl: '/home/avis-clients/',
      isLoggedIn: false,
    },
    {
      linkName: footerTranslate.about.press,
      linkUrl: 'https://ressources.bazarchic.com/contact-presse/',
      linkTarget: '_blank',
      isLoggedIn: false,
    },
  ];

  const FaqLinks = [
    {
      linkName: footerTranslate.help.contactUs,
      linkUrl: '/contact/question/',
      isLoggedIn: false,
    },
    {
      linkName: footerTranslate.help.faq,
      linkUrl: '/faq/index/',
      isLoggedIn: false,
    },
    {
      linkName: footerTranslate.help.termsOfSale,
      linkUrl: 'https://fr.bazarchic.com/contenu/conditions-generales-de-ventes/',
      linkTarget: '_blank',
      isLoggedIn: false,
    },
    {
      linkName: footerTranslate.help.privacyPolicy,
      linkUrl: 'https://fr.bazarchic.com/contenu/politique-de-vie-privee/  ',
      linkTarget: '_blank',
      isLoggedIn: false,
    },
  ];

  const ServicesLinks = [
    {
      linkName: footerTranslate.services.mobileApps,
      linkUrl: '/home/mobilite/',
      isLoggedIn: false,
    },
    // {
    //   linkName: 'Club privilège',
    //   linkUrl: '/accueil/privilege/',
    //   isLoggedIn: false,
    // },
    {
      linkName: footerTranslate.services.referral,
      linkUrl: '/accueil/parrainage/',
      isLoggedIn: true,
    },
    {
      linkName: footerTranslate.services.ourBrands,
      linkUrl: '/marques/',
      isLoggedIn: false,
    },
  ];

  const ClientLinks = [
    {
      linkName: footerTranslate.client.myAccount,
      linkUrl: '/account/index/',
      isLoggedIn: true,
    },
    {
      linkName: footerTranslate.client.myOrders,
      linkUrl: '/commandes/index/',
      isLoggedIn: true,
    },
    {
      linkName: footerTranslate.client.myReturns,
      linkUrl: '/account/retours/',
      isLoggedIn: true,
    },
    {
      linkName: footerTranslate.client.preferencesCenter,
      linkUrl: '/account/newsletters/',
      linkTarget: '',
      isLoggedIn: true,
    },
  ];

  return {
    aProposLinks,
    FaqLinks,
    ServicesLinks,
    ClientLinks,
  };
};

export const aProposLinks = [
  {
    linkName: 'Qui Sommes nous',
    linkUrl: '/home/whois/',
    isLoggedIn: false,
  },
  {
    linkName: 'Le magazine',
    linkUrl: '/magazine/index/',
    isLoggedIn: false,
  },
  {
    linkName: 'Avis clients',
    linkUrl: '/home/avis-clients/',
    isLoggedIn: false,
  },
  {
    linkName: 'Presse',
    linkUrl: 'https://ressources.bazarchic.com/contact-presse/',
    linkTarget: '_blank',
    isLoggedIn: false,
  },
];

export const FaqLinks = [
  {
    linkName: 'Nous contacter',
    linkUrl: '/contact/question/',
    isLoggedIn: false,
  },
  {
    linkName: 'F.A.Q',
    linkUrl: '/faq/index/',
    isLoggedIn: false,
  },
  {
    linkName: 'Conditions générales de vente',
    linkUrl: 'https://fr.bazarchic.com/contenu/conditions-generales-de-ventes/',
    linkTarget: '_blank',
    isLoggedIn: false,
  },
  {
    linkName: 'Politique de Vie Privée',
    linkUrl: 'https://fr.bazarchic.com/contenu/politique-de-vie-privee/  ',
    linkTarget: '_blank',
    isLoggedIn: false,
  },
];

export const ServicesLinks = [
  {
    linkName: 'Applications mobiles',
    linkUrl: '/home/mobilite/',
    isLoggedIn: false,
  },
  // {
  //   linkName: 'Club privilège',
  //   linkUrl: '/accueil/privilege/',
  //   isLoggedIn: false,
  // },
  {
    linkName: 'Parrainage',
    linkUrl: '/accueil/parrainage/',
    isLoggedIn: true,
  },
  {
    linkName: 'Nos marques',
    linkUrl: '/marques/',
    isLoggedIn: false,
  },
  {
    linkName: 'Offres du moment',
    linkUrl: 'https://fr.bazarchic.com/contenu/',
    isLoggedIn: false,
  },
];

export const ClientLinks = [
  {
    linkName: 'Mon compte',
    linkUrl: '/account/index/',
    isLoggedIn: true,
  },
  {
    linkName: 'Mes commandes',
    linkUrl: '/commandes/index/',
    isLoggedIn: true,
  },
  {
    linkName: 'Mes bons de retours',
    linkUrl: '/account/retours/',
    isLoggedIn: true,
  },
  {
    linkName: 'Mon centre de préférences',
    linkUrl: '/account/newsletters/',
    linkTarget: '',
    isLoggedIn: true,
  },
];
